export enum LinkButtonSize {
  L = "l",
  M = "m",
  S = "s",
}

export interface LinkButtonProps {
  title?: React.ReactNode;
  className?: string;
  onClick?: (e?: any) => void;
  to?: string;
  external?: boolean;
  size?: LinkButtonSize;
  disabled?: boolean | undefined;
  icon?: string | React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  rightIcon?: string | React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  iconClassName?: string;
  rightIconClassName?: string;
}
